/*
 * Copyright © 2026 MS IMAGES. All rights reserved.
 * Proprietary and confidential — unauthorized copying, distribution, or use
 * of this file, via any medium, is strictly prohibited. See LICENSE.
 */

import { UatTestItemDef } from '@/types/uat.types';

export const UAT_CATEGORIES = [
  'products', 'inventory', 'partners', 'sales', 'purchasing',
  'cashBank', 'fxConfig', 'reports', 'pos', 'admin',
] as const;

export type UatCategory = typeof UAT_CATEGORIES[number];

export const UAT_TEST_ITEMS: UatTestItemDef[] = [
  { code: 'PRODUCT_CREATE', category: 'products', targetPath: '/venta/products/new' },
  { code: 'PRODUCT_LIST_SEARCH', category: 'products', targetPath: '/venta/products' },
  { code: 'PRODUCT_EDIT', category: 'products', targetPath: '/venta/products' },
  { code: 'CATEGORY_MANAGE', category: 'products', targetPath: '/venta/categories' },
  { code: 'UNITS_OF_MEASURE', category: 'products', targetPath: '/venta/units-of-measure' },
  { code: 'STOCK_DASHBOARD', category: 'inventory', targetPath: '/venta/stock' },
  { code: 'STOCK_ADJUSTMENT', category: 'inventory', targetPath: '/venta/stock/adjust' },
  { code: 'LOW_STOCK_ALERTS', category: 'inventory', targetPath: '/venta/stock/alerts' },
  { code: 'LOCATION_MANAGE', category: 'inventory', targetPath: '/venta/locations' },
  { code: 'STOCK_TRANSFER', category: 'inventory', targetPath: '/venta/transfers/new' },
  { code: 'INVENTORY_COUNT', category: 'inventory', targetPath: '/venta/inventory-counts' },
  { code: 'PARTNER_CREATE_BUYER', category: 'partners', targetPath: '/venta/partners/new' },
  { code: 'PARTNER_CREATE_SELLER', category: 'partners', targetPath: '/venta/partners/new' },
  { code: 'PARTNER_LIST_FILTER', category: 'partners', targetPath: '/venta/partners' },
  { code: 'QUOTATION_CREATE', category: 'sales', targetPath: '/venta/quotations/new' },
  { code: 'QUOTATION_TO_ORDER', category: 'sales', targetPath: '/venta/quotations' },
  { code: 'SALES_ORDER_CREATE', category: 'sales', targetPath: '/venta/sales-orders/new' },
  { code: 'INVOICE_CREATE', category: 'sales', targetPath: '/venta/invoices/new' },
  { code: 'INVOICE_PDF_PREVIEW', category: 'sales', targetPath: '/venta/invoices' },
  { code: 'CREDIT_NOTE_CREATE', category: 'sales', targetPath: '/venta/invoices' },
  { code: 'DEBIT_NOTE_VIEW', category: 'sales', targetPath: '/venta/purchasing/debit-notes' },
  { code: 'PURCHASE_ORDER_CREATE', category: 'purchasing', targetPath: '/venta/purchase-orders/new' },
  { code: 'GOODS_RECEIPT_CREATE', category: 'purchasing', targetPath: '/venta/goods-receipts/new' },
  { code: 'PURCHASE_RETURN', category: 'purchasing', targetPath: '/venta/purchase-returns/new' },
  { code: 'CASH_REGISTER_CREATE', category: 'cashBank', targetPath: '/venta/cash-registers/new' },
  { code: 'BANK_ACCOUNT_CREATE', category: 'cashBank', targetPath: '/venta/bank-accounts/new' },
  { code: 'CASH_RECEIPT', category: 'cashBank', targetPath: '/venta/cash-receipts/new' },
  { code: 'PAYMENT_VOUCHER', category: 'cashBank', targetPath: '/venta/payment-vouchers/new' },
  { code: 'BANK_TRANSFER', category: 'cashBank', targetPath: '/venta/bank-transfers/new' },
  { code: 'RECONCILIATION', category: 'cashBank', targetPath: '/venta/reconciliation' },
  { code: 'FX_RATES_MANAGE', category: 'fxConfig', targetPath: '/venta/fx-rates' },
  { code: 'TAX_CONFIG', category: 'fxConfig', targetPath: '/venta/tax-config' },
  { code: 'DOCUMENT_NUMBERING', category: 'fxConfig', targetPath: '/venta/doc-numbering' },
  { code: 'SALES_REPORT', category: 'reports', targetPath: '/venta/reports/sales' },
  { code: 'INVENTORY_VALUATION', category: 'reports', targetPath: '/venta/reports/inventory/valuation' },
  { code: 'CASH_FLOW_REPORT', category: 'reports', targetPath: '/venta/reports/financial/cash-flow' },
  { code: 'AGING_REPORT', category: 'reports', targetPath: '/venta/reports/financial/aging' },
  { code: 'POS_REGISTER_SELECT', category: 'pos', targetPath: '/venta/pos/select-register' },
  { code: 'POS_SALE', category: 'pos', targetPath: '/venta/pos' },
  { code: 'USER_MANAGEMENT', category: 'admin', targetPath: '/venta/admin/users' },
  { code: 'ROLES_PERMISSIONS', category: 'admin', targetPath: '/venta/admin/roles' },
];
